"use client";
import { DEFAULT_LOCALE } from "@/i18n/routing";
import useJapanAreasStore from "@/store/hooks/useGlobal";
import { clientSessionManager } from "@/lib/clientSessionManager";
import { useEffect } from "react";
import { useHasHydrated } from "@/hooks/useHasHydrated/useHasHydrated";
// Handles global initialization logic such as fetching Japan area data and session setup

export const GlobalData = () => {
  const { fetchAreas } = useJapanAreasStore();
  const hasHydrated = useHasHydrated();
  // Fetch Japan areas only after hydration and handle draft mode state

  useEffect(() => {
    if (hasHydrated) {
      const isDraftMode = globalThis.location.href.includes("status=DRAFT");
      fetchAreas(DEFAULT_LOCALE, isDraftMode);
    }
  }, [fetchAreas, hasHydrated]);
  // Initialize or validate client session once hydration is complete

  useEffect(() => {
    const initializeSession = async () => {
      await clientSessionManager.ensureValidSession();
    };
    initializeSession();
  }, [hasHydrated]);

  useEffect(() => {
    if (!globalThis.location.href.includes("status=DRAFT")) {
      fetch("/api/disable-preview");
    }
  }, []);

  return <></>;
};
